(() => {
  if (window.feaRelatedProductsToggleReady) return;
  window.feaRelatedProductsToggleReady = true;

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('[data-fea-related-toggle]');
    if (!button) return;

    const recommendations = button.closest('product-recommendations');
    if (!recommendations) return;

    const extraProducts = recommendations.querySelectorAll('[data-fea-related-extra]');
    const willExpand = button.getAttribute('aria-expanded') !== 'true';

    extraProducts.forEach((product) => {
      product.hidden = !willExpand;
    });

    button.setAttribute('aria-expanded', String(willExpand));

    const label = button.querySelector('[data-fea-related-toggle-label]');
    if (label) {
      label.textContent = willExpand ? button.dataset.closeLabel : button.dataset.openLabel;
    }
  });
})();
